import { jsxs as r, jsx as e } from "react/jsx-runtime";
function l(o) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "33", viewBox: "0 0 296 33", width: "296", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ e("g", { filter: "url(#filter0_dd_581_98102)", children: /* @__PURE__ */ e("path", { d: "M10 6.5L10 24.5L3 24.5L5.1 15.5L3 6.5L10 6.5Z", fill: "#FBDA2E" }) }),
    /* @__PURE__ */ e("g", { filter: "url(#filter1_dd_581_98102)", children: /* @__PURE__ */ e("path", { d: "M286 25L286 9L293 9L290.9 17L293 25L286 25Z", fill: "#FBDA2E" }) }),
    /* @__PURE__ */ e("g", { filter: "url(#filter2_dd_581_98102)", children: /* @__PURE__ */ e("rect", { fill: "#FBDA2E", height: "27", rx: "4", width: "276", x: "10", y: "2" }) }),
    /* @__PURE__ */ r("defs", { children: [
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "24",
          id: "filter0_dd_581_98102",
          width: "13",
          x: "0",
          y: "4.5",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_581_98102" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_581_98102" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_581_98102", mode: "normal", result: "effect2_dropShadow_581_98102" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_581_98102", mode: "normal", result: "shape" })
          ]
        }
      ),
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "22",
          id: "filter1_dd_581_98102",
          width: "13",
          x: "283",
          y: "7",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_581_98102" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_581_98102" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_581_98102", mode: "normal", result: "effect2_dropShadow_581_98102" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_581_98102", mode: "normal", result: "shape" })
          ]
        }
      ),
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "33",
          id: "filter2_dd_581_98102",
          width: "282",
          x: "7",
          y: "0",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_581_98102" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_581_98102" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_581_98102", mode: "normal", result: "effect2_dropShadow_581_98102" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_581_98102", mode: "normal", result: "shape" })
          ]
        }
      )
    ] })
  ] });
}
export {
  l as default
};
